var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',[_c('Hearder')],1),_c('el-main',[_c('AppMain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }